export function PreviewCounter({ used, limit = 3 }: { used: number; limit?: number }) {
  const shown = Math.min(used, limit);
  return (
    <p className="muted" aria-live="polite">
      {shown} of {limit} object previews
    </p>
  );
}
